export { default } from './product';
